export default __webpack_public_path__ + "static/media/colibri.a2a268fa.jpg";